import { useEffect } from 'react';
import { useContent } from './content';

export const FONT_PRESETS = [
  { id: '', label: 'Default (Google Sans Flex)' },
  { id: 'manrope', label: 'Manrope', css: "'Manrope', sans-serif", url: 'https://fonts.googleapis.com/css2?family=Manrope:wght@300..800&display=swap' },
  { id: 'space-grotesk', label: 'Space Grotesk', css: "'Space Grotesk', sans-serif", url: 'https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300..700&display=swap' },
  { id: 'dm-sans', label: 'DM Sans', css: "'DM Sans', sans-serif", url: 'https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300..800&display=swap' },
  { id: 'playfair', label: 'Playfair Display', css: "'Playfair Display', serif", url: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400..800&display=swap' },
  { id: 'libre-baskerville', label: 'Libre Baskerville', css: "'Libre Baskerville', serif", url: 'https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&display=swap' },
];

function applyTheme(s) {
  let el = document.getElementById('ditec-theme');
  if (!el) {
    el = document.createElement('style');
    el.id = 'ditec-theme';
    document.head.appendChild(el);
  }
  const css = [];
  const color = (val, cls) => {
    if (val) css.push(`.bg-${cls}{background-color:${val}!important}`, `.text-${cls}{color:${val}!important}`, `.border-${cls}{border-color:${val}!important}`);
  };
  color(s.colorNavy, 'navy');
  color(s.colorAccent, 'electric');
  color(s.colorGold, 'gold');
  color(s.colorPaper, 'paper');
  const preset = FONT_PRESETS.find((f) => f.id === s.fontPreset);
  let link = document.getElementById('ditec-font-preset');
  if (preset?.url) {
    if (!link) {
      link = document.createElement('link');
      link.id = 'ditec-font-preset';
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }
    link.href = preset.url;
    css.push(`body{font-family:${preset.css}!important}`);
  } else if (link) link.remove();
  if (s.customFontUrl) {
    css.push(`@font-face{font-family:'DITEC Custom';src:url('${s.customFontUrl}');font-display:swap}`, `body{font-family:'DITEC Custom',sans-serif!important}`);
  }
  if (s.fontScale === 'compact') css.push('html{font-size:15px}');
  if (s.fontScale === 'large') css.push('html{font-size:17.5px}');
  el.textContent = css.join('\n');
}

function applyTracking(s) {
  if (s.gtmId && !document.getElementById('ditec-gtm')) {
    const sc = document.createElement('script');
    sc.id = 'ditec-gtm';
    sc.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${s.gtmId}');`;
    document.head.appendChild(sc);
    const ns = document.createElement('noscript');
    ns.id = 'ditec-gtm-ns';
    ns.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${s.gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.prepend(ns);
  }
  document.querySelectorAll('[data-ditec-custom]').forEach((n) => n.remove());
  if (s.customHead) {
    try {
      const parsed = new DOMParser().parseFromString(s.customHead, 'text/html');
      parsed.querySelectorAll('meta,link,script,style').forEach((el) => {
        if (el.tagName === 'SCRIPT') {
          const nsc = document.createElement('script');
          [...el.attributes].forEach((a) => nsc.setAttribute(a.name, a.value));
          nsc.textContent = el.textContent;
          nsc.setAttribute('data-ditec-custom', '1');
          document.head.appendChild(nsc);
        } else {
          const clone = el.cloneNode(true);
          clone.setAttribute('data-ditec-custom', '1');
          document.head.appendChild(clone);
        }
      });
    } catch (e) { /* ignore malformed snippets */ }
  }
}

export default function SiteInjectors() {
  const { settings } = useContent();
  useEffect(() => { applyTheme(settings); }, [settings]);
  useEffect(() => { applyTracking(settings); }, [settings]);
  return null;
}
